var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "synonyms-item" }, [
    _c(
      "div",
      { staticClass: "synonyms-item-form" },
      [
        _c("div", { staticClass: "item-head" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.entry.value,
                expression: "entry.value",
              },
            ],
            staticClass: "form-input",
            attrs: { placeholder: _vm.$t("chatbotv2.title"), autofocus: true },
            domProps: { value: _vm.entry.value },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.entry, "value", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "delete-item", on: { click: _vm.deleteEntry } },
            [_c("md-icon", [_vm._v("delete")])],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticClass: "form-select-input",
            attrs: {
              mode: "tags",
              placeholder: _vm.$t("chatbotv2.synonyms"),
              autofocus: true,
            },
            on: { blur: _vm.synonymInputBlurHandler },
            model: {
              value: _vm.entry.synonyms,
              callback: function ($$v) {
                _vm.$set(_vm.entry, "synonyms", $$v)
              },
              expression: "entry.synonyms",
            },
          },
          _vm._l(_vm.entry.synonyms, function (i) {
            return _c("a-select-option", { key: i }, [
              _vm._v("\n                " + _vm._s(i) + "\n            "),
            ])
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }